import { Box, IconButton, Tooltip } from '@mui/material';
import RadarIcon from '@mui/icons-material/Radar';
import { useMapStore } from '../../stores/map/useMapStore';
import { useScreenStore } from '../../stores/useScreenStore';
import { usePermissions } from '../../hooks/auth/usePermissions';
import CloseIcon from '@mui/icons-material/Close';
import MapView from './MapView';
import MapPontosPanel from './MapPontosPanel';
import MapPezinhoPanel from './MapPezinhoPanel';

export default function MapLayout() {

    const openMap = useMapStore(state => state.openMap);
    const screen = useScreenStore(state => state.screen);
    const monitorMode = useScreenStore(state => state.monitorMode);
    const loadingMap = useScreenStore(state => state.loadingMap);

    const { canShowPezinho } = usePermissions();

    const pezinhoActive = useMapStore(
        state => state.pezinho.active
    );

    const pezinhoLoading = useMapStore(
        state => state.pezinho.loading
    );

    const setPezinhoActive = useMapStore(
        state => state.setPezinhoActive
    );

    const controlsDisabled =
        loadingMap ||
        pezinhoLoading;

    if(!openMap || (monitorMode === 2 && screen !== 'Filtros')) {
        return null;
    }

    return (
        <Box
            sx={(theme) => ({
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                height: '100vh',
                zIndex: theme.zIndex.modal - 1,
                backgroundColor: theme.palette.background.default,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
            })}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    zIndex: 10000,
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 1
                }}
            >
                {pezinhoActive && (
                    <MapPezinhoPanel />
                )}
                {canShowPezinho && (
                    <Tooltip
                        title={
                            pezinhoActive
                                ? 'Desativar busca de veículos'
                                : 'Ver veículos no ponto'
                        }
                    >
                        <span>
                            <IconButton
                                onClick={() => {
                                    setPezinhoActive(!pezinhoActive);
                                }}
                                disabled={controlsDisabled}
                                sx={(theme) => ({
                                    color: pezinhoActive
                                        ? theme.palette.primary.contrastText
                                        : theme.palette.text.primary,

                                    backgroundColor: pezinhoActive
                                        ? theme.palette.primary.main
                                        : theme.palette.background.paper,

                                    '&:hover': {
                                        backgroundColor: pezinhoActive
                                            ? theme.palette.primary.dark
                                            : theme.palette.action.hover
                                    }
                                })}
                            >
                                <RadarIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                )}

                <Tooltip title="Fechar mapa">
                    <span>
                        <IconButton
                            onClick={() => {
                                useMapStore
                                    .getState()
                                    .setCloseMap();
                            }}
                            disabled={controlsDisabled}
                            sx={(theme) => ({
                                backgroundColor:
                                    theme.palette.background.paper,

                                '&:hover': {
                                    backgroundColor:
                                        theme.palette.action.hover
                                }
                            })}
                        >
                            <CloseIcon />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>

            <Box
                sx={{
                    height: '60vh',
                    minHeight: 0
                }}
            >
                <MapView />
            </Box>

            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden'
                }}
            >
                <MapPontosPanel />
            </Box>

        </Box>
    );
}